/**
 * Alphabet Filter for Brand/Vendor
 * Filters brand list by clicking on alphabet letters
 */

class AlphabetFilter {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    const alphabetContainers = document.querySelectorAll('.alphabet-filter');
    
    alphabetContainers.forEach(container => {
      const letters = container.querySelectorAll('.alphabet-letter');
      const detailsElement = container.closest('details');
      
      if (!detailsElement) return;
      
      // Get all brand items (checkbox list items)
      const brandList = detailsElement.querySelector('.accordion-details__content ul');
      if (!brandList) return;
      
      const brandItems = brandList.querySelectorAll('li');
      
      // Add click listeners to alphabet letters
      letters.forEach(letter => {
        letter.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const selectedLetter = letter.dataset.letter;
          
          // Update active state
          letters.forEach(l => {
            l.style.background = 'transparent';
            l.style.fontWeight = 'normal';
          });
          
          letter.style.background = 'var(--color-button)';
          letter.style.color = 'var(--color-button-text)';
          letter.style.fontWeight = '600';
          
          // Filter brands
          this.filterBrands(brandItems, selectedLetter);
        });
      });
      
      // Auto-detect which letters have brands and disable empty ones
      this.updateLetterStates(letters, brandItems);
    });
  }

  filterBrands(brandItems, letter) {
    brandItems.forEach(item => {
      const label = item.querySelector('label');
      if (!label) return;
      
      const brandName = label.textContent.trim();
      const firstLetter = brandName.charAt(0).toUpperCase();
      
      if (letter === 'all') {
        // Show all brands
        item.style.display = 'flex';
      } else if (firstLetter === letter) {
        // Show brands starting with this letter
        item.style.display = 'flex';
      } else {
        // Hide other brands
        item.style.display = 'none';
      }
    });
  }

  updateLetterStates(letters, brandItems) {
    const availableLetters = new Set();
    
    // Collect first letters of all brands
    brandItems.forEach(item => {
      const label = item.querySelector('label');
      if (!label) return;
      
      const brandName = label.textContent.trim();
      const firstLetter = brandName.charAt(0).toUpperCase();
      
      // Check if brand has products (not disabled)
      const checkbox = item.querySelector('input[type="checkbox"]');
      if (checkbox && !checkbox.disabled) {
        availableLetters.add(firstLetter);
      }
    });
    
    // Disable letters that don't have any brands
    letters.forEach(letter => {
      const letterValue = letter.dataset.letter;
      
      // Skip "all" button
      if (letterValue === 'all') return;
      
      if (!availableLetters.has(letterValue)) {
        letter.disabled = true;
        letter.style.opacity = '0.3';
        letter.style.cursor = 'not-allowed';
        letter.style.color = 'var(--color-foreground-secondary)';
      }
    });
  }
}

// Initialize
new AlphabetFilter();

